var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveSite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.blueprint_een{fill:#111918;}\r\n\t.st0{fill:#0B1719;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "blueprint_een",
    d: "M30,3H2C1.448,3,1,3.448,1,4v24c0,0.552,0.448,1,1,1h28c0.552,0,1-0.448,1-1V4 C31,3.448,30.552,3,30,3z M29,27H3V5h26V27z M10.5,17H4v-1h6.109l1.905-7.621c0.111-0.445,0.859-0.445,0.971,0l3.515,14.06 l2.515-10.06c0.111-0.445,0.859-0.445,0.971,0L20.891,16H28v1h-7.5c-0.229,0-0.43-0.156-0.485-0.379l-0.515-2.06l-2.515,10.06 C16.93,24.844,16.729,25,16.5,25s-0.43-0.156-0.485-0.379L12.5,10.562l-1.515,6.06C10.93,16.844,10.729,17,10.5,17z M6,25H4v-1h2V25 z M6,21H4v-1h2V21z M6,13H4v-1h2V13z M6,9H4V8h2V9z M26,24h2v1h-2V24z M26,20h2v1h-2V20z M28,13h-2v-1h2V13z M28,9h-2V8h2V9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveSite);
export default __webpack_public_path__ + "static/media/live-site.d77e4764e15b94335ea31e71082d88a1.svg";
export { ForwardRef as ReactComponent };